var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-3 mt-5 pt-3"},[_c('ComponentOtp',{attrs:{"target-sent-otp":_vm.targetSentOtp,"error-message":_vm.errorMessage,"is-start-countdown":_vm.startCountdown,"timestamp-expired":_vm.timestampExpired,"otp":_vm.otp},on:{"setOtp":_vm.setOtp,"validateOtp":_vm.validateOtp,"resendOtp":_vm.resendOtp}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }